export function calculatePutOptionBasis(strikePrice: number, mid: number): number {
    return Number((strikePrice - mid));
}
